import { memo } from "react";
import * as Styled from "./style";
import { SamplePackageImage } from "~/components/blocks/common/sample-package-image";
import { SampleVisualImage } from "~/components/blocks/product/detail/sample-visual-image";
import type { VideoStageSeasonType } from "~/components/blocks/product/type-guard";
import { useImageSrcFormat } from "~/hooks/use-image-src-format";

type VideoStageSeasonHeaderProps = {
  videoStageSeasonData: VideoStageSeasonType;
};

/**
 * 作品末端の舞台のサンプル画像を管理するコンポーネント
 * - 舞台作品には再生動線が存在しないのでこの実装方法で問題なし！
 * @param props {@link VideoStageSeasonHeaderProps}
 */
export const VideoStageSeasonHeader = memo((props: VideoStageSeasonHeaderProps) => {
  const { videoStageSeasonData } = props;

  const { packageImage, keyVisualImage, keyVisualWithoutLogoImage } = videoStageSeasonData;

  const { imageSrcFormat } = useImageSrcFormat({ aspectRatio: "LANDSCAPE" });

  // HACK: imgSrcに渡す値を条件分岐してあげればもっと短く綺麗にかける
  if (keyVisualImage) {
    return (
      <>
        <SampleVisualImage
          {...imageSrcFormat({ imgSrc: keyVisualImage, size: { w: 1920, h: 1080 } })}
          alt="ロゴがあるキービジュアル画像"
        />
        <Styled.VideoForSeoOptimization />
      </>
    );
  }

  if (keyVisualWithoutLogoImage) {
    return (
      <>
        <SampleVisualImage
          {...imageSrcFormat({ imgSrc: keyVisualWithoutLogoImage, size: { w: 1920, h: 1080 } })}
          alt="ロゴがないキービジュアル画像"
        />
        <Styled.VideoForSeoOptimization />
      </>
    );
  }

  if (packageImage) {
    return (
      <>
        <SamplePackageImage packageImageUrl={packageImage} />
        <Styled.VideoForSeoOptimization />
      </>
    );
  }

  return null;
});

VideoStageSeasonHeader.displayName = "VideoStageSeasonHeader";
